import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const streamLineComponent = Loadable(() => import('../containers/index'));
const LQBanner = Loadable(() => import('../../../components/NextGen/StreamLineOrder/LQBanner'));

export default MapTo('vcg/components/soe-home/react/lqBannerHomeLQ')(LQBanner)(MapTo('vcg/components/soe-home/react/streamlineorder')(streamLineComponent)
);
